import { createStyles } from '@zn-material-ui'
export default createStyles({
  root: {
    minWidth: '150px',
    display: 'inline-block',
    marginRight: '10px',
    position: 'relative',
  },
  paper: {
    borderRadius: 0,
    boxShadow: 'none',
    background: 'transparent',
    position: 'fixed',
  },
  menuList: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  selected: {
    '& a': {
      color: '#fff !important',
    },
    backgroundColor: '#FA534A !important',
  },
  menuItem: {
    boxSizing: 'border-box',
    width: 150,
    height: 40,
    display: 'flex',
    borderRadius: '2px',
    marginBottom: '6px',
    justifyContent: 'center',
    padding: '0 !important',
    whiteSpace: 'nowrap',
    '& a': {
      textDecoration: 'none',
      minWidth: 110,
      height: 40,
      textAlign: 'center',
      color: '#333',
      lineHeight: '41px',
    },
    '&:hover': {
      backgroundColor: '#FA534A',
      '& a': {
        color: '#fff',
        '&:active': {
          backgroundColor: '#DD2525',
          borderRadius: '2px',
        },
      },
    },
  },
})
